import ethBase from "@/lib/eth/ethCall/base";
import {ethers} from "ethers";
import config from "@/config";

let proposalFactoryContract
let proposalFactoryWithSigner

function init(){
    if (!proposalFactoryContract || !proposalFactoryWithSigner) {
        const {provider, signer} = ethBase.getEthProviderAndSigner()

        proposalFactoryContract = new ethers.Contract(
            config.blockchainConfig.contractAddresses.proposalFactory,
            config.contractAbi.proposalFactory,
            provider
        )

        proposalFactoryWithSigner = proposalFactoryContract.connect(signer)
    }
}

async function newProposal(uri, spendingRequirement, optionNum, startTime, duration) {
    if (!proposalFactoryWithSigner) {
        init()
    }
    console.log(uri, spendingRequirement, optionNum, startTime, duration)
    const tx = await proposalFactoryWithSigner.newProposal(
        uri, spendingRequirement, optionNum, startTime, duration
    );
    return await tx.wait()
}

async function vote(storeAccount, proposalId, option) {
    if (!proposalFactoryWithSigner) {
        init()
    }
    const tx = await proposalFactoryWithSigner.vote(
        storeAccount, proposalId, option
    );
    return await tx.wait()
}

export default {
    newProposal,
    vote
}